'use strict'

module.exports = { version: '10.3.0' }
